import { createContext } from "../../__compat__/react/main.entry.mjs.mjs";
// Same as default but we need it for StyledPopover
export const containerPadding = 12;
export const PopoverContext = createContext({
    containerPadding,
});
//# sourceMappingURL=context.mjs.mjs.map